import React, { useState, useEffect, useCallback } from "react";
import { connect } from 'react-redux'
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

export const AgGridTable = (props) => {

    return (
        <div className="ag-theme-alpine" style={{ height: 400, }}>
            <AgGridReact
                rowData={props.data}
                columnDefs={props.columnDefs}
                defaultColDef={props.defaultColDef}
            >
            </AgGridReact>
        </div>
    )
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(AgGridTable)